var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-content',[_c('v-select',{attrs:{"items":_vm.selectGroups,"label":"소속그룹","outlined":"","dense":"","value":_vm.group,"hide-details":""},on:{"change":_vm.update}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }